<template>
  <div>
    <div class="d-flex">
      <div class="pb-3 pl-2 w-50-porcento">
        <div class="position-absolute ml-2 mt-n10px h-15px font-12 bg-white z-999 px-1">Segmento</div>

        <SysSegmentoAutocomplete
          v-model="filtros.segmentos"
          :ids-grupo="filtros.grupos"
          :ids-filial="filtros.filiais"
          outlined
          multiple
          :qtde-visivel-selecionados="1"
          clearable
          hide-details
          append-icon="mdi-filter"
          :dense="autocomplete_dense"
          @focus="focus_inputs.segmento = true"
          @blur="focus_inputs.segmento = false"
        >
          <template #prepend-inner v-if="filtros.segmentos.length === 0 && !focus_inputs.segmento">
            <div class="position-absolute mt-1">Geral</div>
          </template>
        </SysSegmentoAutocomplete>
      </div>

      <div class="pb-3 pl-2 w-50-porcento">
        <div class="position-absolute ml-2 mt-n10px h-15px font-12 bg-white z-999 px-1">Fornecedor</div>

        <SysFornecedorAutocomplete
          v-model="filtros.fornecedores"
          :ids-grupo="filtros.grupos"
          :ids-filial="filtros.filiais"
          :ids-segmento="filtros.segmentos"
          :ids-secao="filtros.secoes"
          :ids-comprador="filtros.compradores"
          outlined
          multiple
          :qtde-visivel-selecionados="1"
          clearable
          hide-details
          append-icon="mdi-filter"
          :dense="autocomplete_dense"
          @focus="focus_inputs.fornecedor = true"
          @blur="focus_inputs.fornecedor = false"
        >
          <template #prepend-inner v-if="filtros.fornecedores.length === 0 && !focus_inputs.fornecedor">
            <div class="position-absolute mt-1">Geral</div>
          </template>
        </SysFornecedorAutocomplete>
      </div>
    </div>

    <div class="d-flex">
      <div class="pb-3 pl-1 w-50-porcento">
        <div class="position-absolute ml-2 mt-n10px h-15px font-12 bg-white z-999 px-1">Seção</div>

        <SysSecaoAutocomplete
          v-model="filtros.secoes"
          outlined
          multiple
          :qtde-visivel-selecionados="1"
          :ids-grupo="filtros.grupos"
          :ids-filial="filtros.filiais"
          :ids-segmento="filtros.segmentos"
          clearable
          hide-details
          append-icon="mdi-filter"
          :dense="autocomplete_dense"
          @focus="focus_inputs.secao = true"
          @blur="focus_inputs.secao = false"
        >
          <template #prepend-inner v-if="filtros.secoes.length === 0 && !focus_inputs.secao">
            <div class="position-absolute mt-1">Geral</div>
          </template>
        </SysSecaoAutocomplete>
      </div>

      <div class="pb-3 pl-2 w-50-porcento">
        <div class="position-absolute ml-2 mt-n10px h-15px font-12 bg-white z-999 px-1">Categoria</div>

        <SysCategoriaAutocomplete
          v-model="filtros.categorias"
          :ids-grupo="filtros.grupos"
          :ids-filial="filtros.filiais"
          :ids-segmento="filtros.segmentos"
          :ids-secao="filtros.secoes"
          outlined
          multiple
          :qtde_visivel_selecionados="1"
          clearable
          hide-details
          append-icon="mdi-filter"
          :dense="autocomplete_dense"
          @focus="focus_inputs.categoria = true"
          @blur="focus_inputs.categoria = false"
        >
          <template #prepend-inner v-if="filtros.categorias.length === 0 && !focus_inputs.categoria">
            <div class="position-absolute mt-1">Geral</div>
          </template>
        </SysCategoriaAutocomplete>
      </div>
    </div>
  </div>
</template>

<script>
import SysSegmentoAutocomplete from "@/components/utils/crud/SysSegmentoAutocomplete";
import SysSecaoAutocomplete from "@/components/utils/crud/SysSecaoAutocomplete";
import SysMarcaAutocomplete from "@/components/utils/crud/SysMarcaAutocomplete";
import SysFornecedorAutocomplete from "@/components/utils/crud/SysFornecedorAutocomplete";
import SysCompradorAutocomplete from "@/components/utils/crud/SysCompradorAutocomplete";
import SysGrupoAutocomplete from "@/components/utils/crud/SysGrupoAutocomplete";
import SysFilialGrupoAutocomplete from "@/components/utils/crud/SysFilialGrupoAutocomplete";
import SysCategoriaAutocomplete from "@/components/utils/crud/SysCategoriaAutocomplete.vue";
import SysLinhaAutocomplete from "@/components/utils/crud/SysLinhaAutocomplete.vue";

export default {
  name: "FiltrosPrincipais",
  components: {
    SysFilialGrupoAutocomplete,
    SysGrupoAutocomplete,
    SysCompradorAutocomplete,
    SysFornecedorAutocomplete,
    SysSecaoAutocomplete,
    SysSegmentoAutocomplete,
    SysCategoriaAutocomplete,
    SysLinhaAutocomplete,
    SysMarcaAutocomplete
  },
  props: {
    filtros: Object,
    autocomplete_dense: {
      type: Boolean,
      default: false
    },
    ocultar_filtro_grupos: Boolean,
    ocultar_filtro_filiais: Boolean,
    ocultar_filtro_compradores: Boolean,
    ocultar_filtro_marcas: Boolean
  },
  data: () => ({
    focus_inputs: {
      grupo: false,
      filial: false,
      segmento: false,
      secao: false,
      categoria: false,
      linha: false,
      comprador: false,
      fornecedor: false,
      marca: false
    }
  })
}
</script>

<style scoped>

</style>
